import { useEffect, useState } from "react";
import { handleSSOCallback, getSession, getAuthBaseUrl, type SSOSession } from "@/lib/trustngo-auth";

interface TrustNGOSessionUser {
  id: string;
  email: string;
  user_metadata: {
    full_name: string;
  };
  created_at?: string;
  last_sign_in_at?: string;
  email_confirmed_at?: string;
}

export function useTrustNGOSession() {
  const [user, setUser] = useState<TrustNGOSessionUser | null>(null);
  const [session, setSession] = useState<SSOSession | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for SSO callback token in URL
    handleSSOCallback();

    // Get session from stored token
    const sessionData = getSession();

    if (sessionData) {
      // Check if token is expired
      const now = Math.floor(Date.now() / 1000);
      if (sessionData.exp < now) {
        // Token expired, clear it
        localStorage.removeItem("access_token");
        setSession(null);
        setUser(null);
      } else {
        // Valid session
        setSession(sessionData);
        // Create user object from session data
        setUser({
          id: sessionData.sub,
          email: sessionData.email,
          user_metadata: {
            full_name: sessionData.email?.split('@')[0] || 'User'
          }
        });
      }
    }

    setLoading(false);
  }, []);

  const logout = () => {
    localStorage.removeItem("access_token");
    setSession(null);
    setUser(null);
    window.location.href = getAuthBaseUrl();
  };

  return {
    user,
    session,
    loading,
    logout
  };
}
